import React, { useEffect, useState } from 'react';
import { useStyle } from './PrequalStyle.js';
import { Button, Typography } from '@material-ui/core';
import Constants from '../../Constants';
import PubSub from 'pubsub-js';
import { useLocalStorage } from './EirPrequalPersistance';
import { createOrder } from './EirOrderIntegration';
import PrequalTvChannelsPopUp from './PrequalTvChannelsPopUp';
import { getContext, scrollToTop, checkPrequalForm} from './EirPrequalUtil.js';

export default function EirFixedBundleCardBody(props) {
    const classes = useStyle({
        themeColor: props.themeColor,
        themeColorOnHover: props.themeColorOnHover,
        themeColorForBroadbandCards: props.themeColorForBroadbandCards,
        themeColorForBroadbandCardsHover: props.themeColorForBroadbandCardsHover,
        useBroadbandCardColor: props.useBroadbandCardColor,
    });
    const [expand, setExpand] = useState(false);
    const { getLocalStorage, setLocalStorage } = useLocalStorage();
    const [showButton, setShowButton] = useState(false);
    const context = getContext();
    


    useEffect(() => {
        setEqualHeight();
        if (
            getLocalStorage('eir_prequal_data') &&
            getLocalStorage('prequaled_from') === checkPrequalForm()
        ) {
            setShowButton(true);
        } else setShowButton(false);
    }, [props.resources.BundleData]);
    
    const setEqualHeight = () => {
        let getParentRef = document.querySelector('#bundle_card_data');
        let content = getParentRef.querySelectorAll('.fixedBundleCardBodyDetails');
        let Array = [];

        for (let i = 0; i < content.length; i++) {
            content[i].style.height = 'unset';
        }

        for (let i = 0; i < content.length; i++) {
            Array.push(parseInt(content[i].clientHeight));
        }

        for (let i = 0; i < content.length; i++) {
            content[i].style.height = Math.max.apply(Math, Array) + 'px';
        }
    };
    const createBundleData = async bundleDataId => {
        try {
            if(localStorage.getItem('ACQ_PROSPECTUUID') || localStorage.getItem('CO_REF') || localStorage.getItem('CS_REF')) {
                PubSub.publish(Constants.eventKeys.cartContentChanged, null);
            }
            localStorage.removeItem('ACQ_PROSPECTUUID'); 
            localStorage.removeItem('CO_REF');
            localStorage.removeItem('CS_REF');
            localStorage.removeItem('ACQ_PORTIN');
            setLocalStorage('eir_clicked_bundle_code_from_prequal', bundleDataId);
            const bundleDataCreation = await createOrder(bundleDataId);
        } catch (err) {
            console.log('error while getting subtitle ', err.message);
            // console.log(err);
        }
    };
    const renderContent = content => {
        return { __html: content };
    };
    const handleClick = () => {
        setExpand(!expand);
    };
    const handleClose = expand => {
        setExpand(expand);
    };

    const startingPriceOfBundle = props.resources.BundleData.priceBreakdown.map(price => {
        return price;
    });
    
    const mainFeatureArray = props.resources.BundleData.attributes.filter(item => {
        return item.name === 'mainFeature';
    });
    const featureArray = props.resources.BundleData.attributes.filter(item => {
        return item.name === 'feature';
    });
    const featureArrayImage = props.resources.BundleData.attributes.filter(item => {
        return item.name === 'featureImg';
    });
    return (
        <React.Fragment>
            <div
                className={classes.fixedBundleCardBody}
                onClick={e => {
                    e.stopPropagation();
                    scrollToTop();
                }}>
                <div className='fixedBundleCardBodyDetails'>
                    <Typography className={classes.bundlePrice}>
                        €{startingPriceOfBundle[props.priceIndex].priceFormatted}
                    </Typography>
                    {props.subtitleOfBundle.length > 0 && (
                        <Typography className={classes.bundleSubTitle}>
                            {props.subtitleOfBundle[0]}
                        </Typography>
                    )}
                    {mainFeatureArray && (
                        <Typography className={classes.bundleCardContent}>
                            {mainFeatureArray[0] && mainFeatureArray[0].value}
                        </Typography>
                    )}
                    {featureArray.map((item, index) => (
                        <div key={index} className={classes.prequalBundleCardType}>
                            {featureArrayImage.map(
                                (img, index) =>
                                    item.id === img.parentId && (
                                        <div key={index} className={classes.prequalBundleCardImage}>
                                            <img src={img.value} />
                                        </div>
                                    )
                            )}
                            {item.value.includes('tvChannelPopup') ? (
                                <Typography
                                    className={classes.prequalBundleCardTypeAttributes}
                                    onClick={e => {
                                        e.stopPropagation();
                                        handleClick();
                                    }}
                                    dangerouslySetInnerHTML={renderContent(
                                        item.value
                                    )}></Typography>
                            ) : (
                                <Typography
                                    className={classes.prequalBundleCardTypeAttributes}
                                    dangerouslySetInnerHTML={renderContent(
                                        item.value
                                    )}></Typography>
                            )}
                        </div>
                    ))}
                </div>
                {expand && <PrequalTvChannelsPopUp handleClose={handleClose} />}
                {showButton && (
                    <div className={classes.prequalCTAContainer}>
                        <Button
                            id={'select_bundle_cta'}
                            type='button'
                            text={props.textButton}
                            value={props.resources.BundleData.bundleCode}
                            onClick={() => {
                                createBundleData(props.resources.BundleData.bundleCode);
                            }}
                            className={
                                !props.buttonState
                                    ? classes.prequalBundleButton
                                    : classes.prequalBundleButtonHover
                            }>
                            {props.textButton}
                        </Button>
                    </div>
                )}
            </div>
        </React.Fragment>
    );
}
